import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popup_system = _resolveComponent("popup-system")!

  return (_openBlock(), _createBlock(_component_popup_system, _normalizeProps(_guardReactiveProps({ systemId: _ctx.systemId, system: _ctx.system })), null, 16))
}